import { useNavbar } from "../../hooks";
import styles from "./navbar-search-desktop.module.css";

export function NavbarSearchDesktop() {
  const { renderAutocomplete, searchRightSlot } = useNavbar();

  const hasRightSlot = Boolean(searchRightSlot);

  return (
    <div className={styles.Container}>
      {renderAutocomplete?.({ isDesktop: true })}

      {hasRightSlot && (
        <div className={styles.Slot}>
          {searchRightSlot?.({
            isDesktop: true,
            isMobile: false,
            isTablet: false,
          })}
        </div>
      )}
    </div>
  );
}
